import './AnnotationsPage.scss'
import {useAnnotations} from "../../api/use-annotations-api.js";
import Table from "../util/table/Table.jsx";
import dayjs from "dayjs";
import {useDispatch, useSelector} from "react-redux";
import {FILTER_KEY_ALL, getSpecificAsset} from "../../ducks/assets-duck.js";
import CloseIcon from "mdi-react/CloseIcon.js";
import PencilIcon from "mdi-react/PencilIcon.js";
import InternalLink from "../util/navigation/InternalLink.jsx";
import {APP_ROUTES} from "../../App.jsx";
import {useParams} from "react-router-dom";
import {FILTER_KEY_GLOBAL, filterAnnotations} from "./_helpers.js";
import Card from "../util/card/Card.jsx";
import Button from "../util/Button.jsx";
import PlusIcon from "mdi-react/PlusIcon.js";
import {activateWidePopup} from "../../ducks/popup-duck.js";
import NewAnnotation from "./NewAnnotation.jsx";

export default () => {

    const dispatch = useDispatch()

    const {annotations, deleteAnnotation} = useAnnotations()
    const {assetId, filterId} = useParams()
    const {name} = useSelector(state => getSpecificAsset(state, parseInt(assetId)))

    const annotationsFiltered = filterAnnotations(annotations, filterId, assetId)

    const onClickNewAnnotation = () => {
        dispatch(activateWidePopup(
            <NewAnnotation
                assetId={assetId}
                filterId={filterId}
            />
        ))
    }

    const onClickEditAnnotation = annotation => {
        dispatch(activateWidePopup(
            <NewAnnotation
                annotation={annotation}
            />
        ))
    }

    const onClickDeleteAnnotation = async id => {
        await deleteAnnotation(id)
    }

    return (
        <div className='annotations-page'>
            <h2>
                Annotation management
            </h2>
            <div className='flex-vertical-center options-bar'>
                <div className='filter-selection flex-vertical-center'>
                    {filterId && filterId !== FILTER_KEY_ALL &&
                    <InternalLink
                        to={APP_ROUTES.annotations.replace(':filterId', FILTER_KEY_ALL).replace(':assetId', assetId || '')}
                        className='filter-button flex-vertical-center category'
                        icon={<CloseIcon/>}
                        isIconRight={true}
                    >
                        {filterId}
                    </InternalLink>
                    }
                    {assetId &&
                    <InternalLink
                        to={APP_ROUTES.annotations.replace(':filterId', filterId).replace(':assetId', '')}
                        className='filter-button flex-vertical-center'
                        icon={<CloseIcon/>}
                        isIconRight={true}
                    >
                        {name}
                    </InternalLink>
                    }
                </div>
                <div className='settings'>
                    <Button
                        icon={<PlusIcon />}
                        onClick={onClickNewAnnotation}
                    >
                        New
                    </Button>
                </div>
            </div>
            <Table isRounded={true}>
                <tbody>
                {annotationsFiltered.map(annotation =>
                    <Annotation
                        key={annotation.id}
                        onClickEditAnnotation={onClickEditAnnotation}
                        onClickDeleteAnnotation={onClickDeleteAnnotation}
                        {...annotation}
                    />
                )}
                </tbody>
            </Table>
            {annotationsFiltered.length <= 0 &&
                <Card>
                    No annotations for current filter
                </Card>
            }
        </div>
    )
}


const Annotation = ({id, date, text, asset_id, category_id, onClickEditAnnotation, onClickDeleteAnnotation}) => {
    const {name, code} = useSelector(state => getSpecificAsset(state, asset_id))
    return (
        <tr className='annotation'>
            <td className='date'>
                {dayjs(date).format('YYYY-MM-DD')}
            </td>
            <td>
                {name ?
                    <InternalLink
                        to={APP_ROUTES.annotations.replace(':filterId', FILTER_KEY_ALL).replace(':assetId', asset_id)}
                        className='flex-vertical-center asset-name'
                    >
                        <div>
                            {name}
                        </div>
                        <div className='small code'>
                            {code}
                        </div>
                    </InternalLink>
                    :
                    <InternalLink
                        to={APP_ROUTES.annotations.replace(':filterId', category_id || FILTER_KEY_GLOBAL).replace(':assetId', '')}
                        className='flex-vertical-center category'
                    >
                        {category_id || 'GLOBAL'}
                    </InternalLink>
                }
            </td>
            <td>
                {text}
            </td>
            <td className='option-buttons'>
                <div className='flex-vertical-center'>
                    <button onClick={()=>onClickEditAnnotation({id, date, text, asset_id, category_id})} className='edit-button'>
                        <PencilIcon />
                    </button>
                    <button onClick={()=>onClickDeleteAnnotation(id)} className='delete-button'>
                        <CloseIcon />
                    </button>
                </div>
            </td>
        </tr>
    )
}